import { useState } from 'react';

import { ShigoPermission } from '../../../../auth/permissions';
import { useShigoPermissions } from '../../../../auth/useShigoPermissions';
import {
  defaultIntegrationsFilter,
  type IntegrationSortDirection,
  type IntegrationSortProperty,
  type IntegrationStatus,
} from '../../model';
import {
  IntegrationsTableView,
  type IntegrationsTableController,
} from '../IntegrationsTable/IntegrationsTableView';

export function DemandPartnerIntegrationsTable(props: { demandPartnerId: string }) {
  const { can } = useShigoPermissions();
  const [filter, setFilter] = useState(defaultIntegrationsFilter);
  if (!can(ShigoPermission.DemandIntegrationsRead)) {
    return (
      <div className="border-border bg-card rounded-md border p-6 text-sm">
        You do not have permission to view integrations.
      </div>
    );
  }
  const controller: IntegrationsTableController = {
    filter,
    setSearch: (searchTerm) => {
      setFilter((value) => ({ ...value, searchTerm, page: 0 }));
    },
    setStatuses: (statuses: IntegrationStatus[]) => {
      setFilter((value) => ({ ...value, statuses, page: 0 }));
    },
    setSort: (
      sortProperty: IntegrationSortProperty | null,
      sortDirection: IntegrationSortDirection,
    ) => {
      setFilter((value) => ({ ...value, sortProperty, sortDirection, page: 0 }));
    },
    setPagination: (page, size) => {
      setFilter((value) => ({ ...value, page: size === value.size ? page : 0, size }));
    },
  };
  return (
    <IntegrationsTableView
      controller={controller}
      demandPartnerId={props.demandPartnerId}
      embedded
    />
  );
}
